import { makeObservable, observable, computed } from 'mobx';

export default class IncompleteAccountStore {

  // These default to `true` to avoid flashing
  // the component while it's loading

  @observable hasCharges = true;
  @observable hasPayoutInfo = true;

  @computed get hasValidOrganization () {
    const { organization } = this.app;

    if (!organization) return false;

    return (
      organization.addressId &&
      organization.legalName &&
      organization.businessNumber &&
      organization.phone &&
      organization.email &&
      organization.owners &&
      organization.owners.length > 0
    );
  }

  @computed get isApproved () {
    const { organization } = this.app;

    return organization ? !!organization.approvedAt : false;
  }

  @computed get hasCurrencies () {
    const { organization } = this.app;
    return organization.settings.values.hasSeenCurrencies || false;
  }

  @computed get currentStep () {
    if (!this.hasValidOrganization) return 0;
    if (this.hasValidOrganization && !this.hasCurrencies) return 1;
    if (this.hasValidOrganization && this.hasCurrencies && !this.hasPayoutInfo) return 2;
    if (this.hasValidOrganization && this.hasCurrencies && this.hasPayoutInfo && !this.isApproved) return 3;
    if (this.hasValidOrganization && this.hasCurrencies && this.hasPayoutInfo && this.isApproved) return 4;
  }

  constructor (app) {
    makeObservable(this);
    this.app = app;
    this.client = app.client;
  }

  checkOrganization = organization => {
    const index = this.app.user.organizations.findIndex(org => org.id === organization.id);
    this.app.user.organizations[index] = organization;
    if (this.app.organization && organization.id === this.app.organization.id) {
      this.app.setOrganization(organization.id);
    }
  };

  checkStatus = async () => {
    if (this.app.organization) {
      const { id: organizationId } = this.app.organization;
      const query = { organizationId, $limit: 0 };

      this.hasCharges = !!(await this.client.service('charges').find({ query })).total;
      this.hasPayoutInfo = !!(await this.client.service('payout-information').find({ query })).total;
    }
  };

  onChargeCreated = async (charge) => {
    const { organization } = charge;
    if (this.app.organization && this.app.organization.pubKey === organization) {
      this.checkStatus();
    }
  };

  onPayoutInformationCreated = async (payoutInfo) => {
    const { organizationId } = payoutInfo;
    if (this.app.organization && this.app.organization.id === organizationId) {
      this.checkStatus();
    }
  };

  isStepActive = step => this.currentStep === step;
  isStepComplete = step => this.currentStep > step;
}
